import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function useExpandDetails() {
    const location = useLocation();
    return queryString.parse(location.search).details;
}
